<script>
export default {
  components: {},
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
  <div>
    <div class="account-pages mt-5 mb-5">
      <div class="container">
        <slot />
      </div>
    </div>
    <footer class="footer footer-alt">
      Copyright 2020 @
      <a href="http://99gift.in" class="text-muted" target="_blank">99gift.in</a>
    </footer>
  </div>
</template>
